/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/**
 * @import { IViewerSourceCreator } from '../iframe'
 * @import PoolAsyncFactory from '../pool/pool-async-factory'
 * @import {ViewerSourceFactory} from '../viewer/source'
 */

// TODO Unit testy.
/**
 * Poskytovatel zdrojů pro zobrazování PDF dokumentů.
 * @implements {IViewerSourceCreator}
 */
export default class PdfViewerSourceCreator {
  /**
   * Vytvoří instanci.
   * @param {number} max Maximální počet současně zobrazovaných PDF.
   * @param {PoolAsyncFactory} poolFactory
   * @param {ViewerSourceFactory} sourceFactory
   */
  constructor(max, poolFactory, sourceFactory) {
    this.pool = poolFactory.create(sourceFactory, { max });
    this.sourceFactory = sourceFactory;
  }

  /** @type {IViewerSourceCreator['delete']} */
  delete(source) {
    return new Promise((resolve) => {
      source.getFrame().repair();
      const { pool } = this;
      return resolve(pool.delete(source));
    });
  }

  /** @type {IViewerSourceCreator['destroy']} */
  destroy() {
    // Prázdná metoda pro splnění rozhraní.
    // TODO #295 Zrevidovat rušení u ViewerSourceCreator?
  }

  /** @type {IViewerSourceCreator['getLent']} */
  getLent() {
    return this.pool.getLent();
  }

  /** @type {IViewerSourceCreator['getMax']} */
  getMax() {
    return this.pool.getMax();
  }

  /** @type {IViewerSourceCreator['isUsingVideoElement']} */
  isUsingVideoElement() {
    return false;
  }

  /** @type {IViewerSourceCreator['lend']} */
  lend(parentEl) {
    return new Promise((resolve) => {
      const { sourceFactory } = this;
      sourceFactory.setParentEl(parentEl);
      const source = this.pool.lend();
      return resolve(source);
    });
  }

  /** @type {IViewerSourceCreator['receive']} */
  receive(source) {
    return new Promise((resolve) => resolve(this.pool.delete(source)));
  }

  /** @type {IViewerSourceCreator['replace']} */
  replace() {
    return Promise.resolve();
  }
}
